<template>
    <div>
        <ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active">Aging Report</li>
		</ol>

        <h1 class="page-header">Aging Report</h1>
        <hr>

         <panel class="border border-secondary" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter Option</h4>
            </template>
            <div class="row ">
                <div class="col-lg-3 col-xs-12 mb-2" >
                    <div class="row">
                        <label for="staticEmail" class="col-sm-3 col-form-label col-xs-12"  style="padding-left:0">Month </label>
                        <select class="form-control w-75" v-model="filter.month">
                            <option v-for="(month, index) in monthList" :value="index">{{month}}</option>

                        </select>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
                <div class="col-lg-3 col-xs-12 mb-2" >
                    <div class="row">
                        <label for="staticEmail" class="col-sm-3 col-form-label col-xs-12"  style="padding-left:0">Year</label>
                        <select class="form-control w-75" v-model="filter.year">
                            <option v-for="year in yearList">{{year}}</option>

                        </select>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
                <div class="col-lg-3 col-xs-12 mb-2" >
                    <div class="row">
                        <label for="staticEmail" class="col-sm-3 col-form-label col-xs-12"  style="padding-left:0">Location</label>
                        <select class="form-control w-75" v-model="filter.location">
                            <option v-for="location in locations">{{location}}</option>

                        </select>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
                <div class="col-lg-2 offset-lg-1 col-xs-12">
                    <input type="button" class="btn btn-primary float-right" style="width:100%" @click="search()" value="Search"></input>
                </div>
            </div>
        </panel>

        <!-- min max aging chart-->
        <minMaxAging  v-if="data" style="padding:1%" class="mt-4 mb-4 border border-secondary rounded" :data="data"></minMaxAging>

        <!--Table Aging-->
        <agingTable v-if="data" style="padding:1%;width:100%" class="mt-4 border border-secondary rounded"  :datas="data"></agingTable>
    </div>
</template>

<script>
import minMaxAging from './childComponents/charts/minMaxAging'
import agingTable from './childComponents/agingTable'

export default {
    components: {
        minMaxAging,
        agingTable
    },
    data(){
        var filter = {
            month : new Date().getMonth(),
            year : new Date().getFullYear(),
            location : "DPDC-CIBITUNG"
        }

        let filterTable = JSON.parse(JSON.stringify(filter))
        let yearList = [];
        let yearNow = new Date().getFullYear();

        for(var i = 0 ; i < 10 ; i++){
            yearList.push(yearNow - i);
        }

        return{
            filter : filter,
            filterReady : false,
            yearList : yearList,
            monthList : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
            data : null,
            locations : null
        }
    },
    async mounted(){
        await this.getLocation();
        await this.initialiseFilter();
        this.getData();
    },
    methods : {
        getData(){
            let url = "/api/dashboard/agingUnit" + this.$store.state.filterUrl;

            this.$http.get(url)
            .then((resp)=>{
                this.data = resp.data.data;
                this.$store.state.updateData++;
            })
            .catch((err)=>{
                console.log(err);
            })
        },
        initialiseFilter(){
            var keys = Object.keys(this.filter);
            
            let stringUrl = '?';
            var queryParams = this.filter;

            for(var i = 0 ; i < keys.length; i++){
                
                stringUrl += `${keys[i]}=${queryParams[keys[i]]}&`;
                
            }
            this.$store.state.filterUrl = stringUrl;
            this.filterReady = true;
        },
        async search(){   
            await this.initialiseFilter();
            this.getData()
        },
        getLocation(){
            let url = "/api/location"

            this.$http.get(url)
            .then((resp)=>{
                this.locations = resp.data.data;
            })
            .catch((err)=>{
                console.log(err);
            })
        },
    }
}
</script>